import { RemitDetail } from "us.collection.economy/interfaces";
import { isArray } from "lodash";

/**
 * @description - Get creditor count
 * @param {RemitDetail[]} details Remit details list
 * @returns {number} - No. of creditors
 */
export const getCreditorCount = (details: RemitDetail[]): number => {
  try {
    if (isArray(details)) {
      const creditorNoSet = new Set<string>();

      for (const record of details) {
        creditorNoSet.add(record.creditorNo);
      }
      return creditorNoSet.size;
    } else {
      return 0;
    }
  } catch (error) {
    return 0;
  }
};
